<div class="container">
  <div class="row">
    <div class="col-lg-3 col--flex">
      <ip-shortcut-menu [subscription]="subscription()" [activities]="activities()" />
    </div>

    <div class="col-lg-9">
      <div class="card">
        <subscription-detail-header
          [subscription]="subscription()"
          [showReportIncidentButton]="isCurrentOrganisation()"
        />

        <div class="row">
          <div class="col-12 col-sm-7">
            <table class="table-properties table-properties--no-margin">
              <tr>
                <td>{{ "ServiceElement.Owner" | translate }}</td>
                <td>{{ owner() }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.OwnAlias" | translate }}</td>
                <td>
                  <alias-editor [customerDescription]="customerDescription()" [subscriptionId]="subscriptionId()" />
                </td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.SURFnetDescription" | translate }}</td>
                <td>{{ description() }}</td>
              </tr>
              @if (hasReferences()) {
                <tr third-party-service-ids-row-content [references]="references()"></tr>
              }
              <tr>
                <td>{{ "ServiceElement.ServiceID" | translate }}</td>
                <td>
                  <service-id [subscriptionId]="subscriptionId()" />
                </td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.ProductName" | translate }}</td>
                <td>Internet (aka SURFinternet)</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.ServiceSpeed" | translate }}</td>
                <td>{{ serviceSpeed() | service_speed }}</td>
              </tr>
            </table>
          </div>
          <div class="col-12 col-sm-5">
            <table class="table-properties table-properties--no-margin">
              @if (isIpBgp()) {
                <tr>
                  <td>{{ "ServiceElement.ASNnummer" | translate }}</td>
                  <td>{{ asn() }}</td>
                </tr>
                <tr>
                  <td>{{ "ServiceElement.SURFASNnummer" | translate }}</td>
                  <td>1103</td>
                </tr>
              }
              <tr>
                <td>{{ "ServiceElement.SURFcertfilter" | translate }}</td>
                <td>
                  <div>{{ surfcertFilter() | enabled_or_value }}</div>
                </td>
              </tr>
              @if (isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.Status" | translate }}</td>
                  <td>{{ status() }}</td>
                </tr>
              }
              <tr>
                <td>{{ "ServiceElement.Start" | translate }}</td>
                <td>{{ startDate() | subscription_date }}</td>
              </tr>
              @if (isTerminated()) {
                <tr>
                  <td>{{ "ServiceElement.End" | translate }}</td>
                  <td>{{ endDate() | subscription_date }}</td>
                </tr>
              }
              <tr>
                <td>{{ "ServiceElement.Domain" | translate }}</td>
                <td>{{ domain() }}</td>
              </tr>
              <tr>
                <td>{{ "ServiceElement.RouteringType" | translate }}</td>
                <td>{{ ipRoutingType() }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (isTerminated()) {
    <div class="hide-everything-after-this-div"></div>
  }

  <page-tab [tabconfig]="tabConfig()" [activeTab]="activeTab()" (activeTabEmitter)="tabChange.emit($event)"> </page-tab>

  <div>
    @if (isConfigTabActive()) {
      <div class="section">
        <ip-detail-container [subscription]="subscription()" />
      </div>
      <traffic-line-chart [subjects]="chartSubjects()" />
    } @else if (isGraphicViewTabActive()) {
      <networkgraph [topology]="topology()" [subscription]="subscription()"></networkgraph>
    }
  </div>
</div>
